<template>
  <MainContainer :with-padding="!route.params.id" :transparent="Boolean(route.params.id)">
    <RouterView :key="route.path" />
  </MainContainer>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";

import MainContainer from "@/app/shared/components/organisms/MainContainer.vue";

const route = useRoute();
</script>

<style scoped lang="sass"></style>
